// Definiujemy interfejs dla hierarchicznej struktury kategorii
export interface CategoryItem {
  id: string
  label: string
  count: number
  parentId?: string
  children?: CategoryItem[]
}

// Główne kategorie z pełną strukturą
export const PRODUCT_CATEGORIES_TREE: CategoryItem[] = [
  {
    id: 'Meble',
    label: 'Meble',
    count: 38,
    children: [
      { id: 'Akcesoria meblowe', label: 'Akcesoria meblowe', count: 5, parentId: 'Meble' },
      { id: 'Barki', label: 'Barki', count: 3, parentId: 'Meble' },
      { id: 'Biurka', label: 'Biurka', count: 7, parentId: 'Meble' },
      { id: 'Blaty', label: 'Blaty', count: 4, parentId: 'Meble' },
      { id: 'Bufety', label: 'Bufety', count: 2, parentId: 'Meble' },
      { id: 'Fotele', label: 'Fotele', count: 8, parentId: 'Meble' },
      { id: 'Hokery', label: 'Hokery', count: 3, parentId: 'Meble' },
      { id: 'Komplety wypoczynkowe', label: 'Komplety wypoczynkowe', count: 4, parentId: 'Meble' },
      { id: 'Kontenery', label: 'Kontenery', count: 3, parentId: 'Meble' },
      { id: 'Kredensy i Komody', label: 'Kredensy i Komody', count: 6, parentId: 'Meble' },
      { id: 'Krzesła', label: 'Krzesła', count: 12, parentId: 'Meble' },
      { id: 'Lady', label: 'Lady', count: 2, parentId: 'Meble' },
      { id: 'Ławy i ławki', label: 'Ławy i ławki', count: 5, parentId: 'Meble' },
      { id: 'Łóżeczka', label: 'Łóżeczka', count: 3, parentId: 'Meble' },
      { id: 'Łóżka', label: 'Łóżka', count: 7, parentId: 'Meble' },
      { id: 'Meble łazienkowe', label: 'Meble łazienkowe', count: 8, parentId: 'Meble' },
      { id: 'Meble specjalne', label: 'Meble specjalne', count: 4, parentId: 'Meble' },
      { id: 'Nadstawki', label: 'Nadstawki', count: 2, parentId: 'Meble' },
      { id: 'Narożniki', label: 'Narożniki', count: 6, parentId: 'Meble' },
      { id: 'Panele', label: 'Panele', count: 5, parentId: 'Meble' },
      { id: 'Podstawki', label: 'Podstawki', count: 3, parentId: 'Meble' },
      { id: 'Półki', label: 'Półki', count: 7, parentId: 'Meble' },
      { id: 'Profile meblowe', label: 'Profile meblowe', count: 4, parentId: 'Meble' },
      { id: 'Pufy', label: 'Pufy', count: 3, parentId: 'Meble' },
      { id: 'Regały i Biblioteczki', label: 'Regały i Biblioteczki', count: 8, parentId: 'Meble' },
      { id: 'Skrzynie', label: 'Skrzynie', count: 3, parentId: 'Meble' },
      { id: 'Sofy i Kanapy', label: 'Sofy i Kanapy', count: 9, parentId: 'Meble' },
      { id: 'Stoły i Stoliki', label: 'Stoły i Stoliki', count: 10, parentId: 'Meble' },
      { id: 'Szafki', label: 'Szafki', count: 8, parentId: 'Meble' },
      { id: 'Szafy i Garderoby', label: 'Szafy i Garderoby', count: 7, parentId: 'Meble' },
      { id: 'Szuflady', label: 'Szuflady', count: 4, parentId: 'Meble' },
      { id: 'Tablice', label: 'Tablice', count: 2, parentId: 'Meble' },
      { id: 'Taborety', label: 'Taborety', count: 3, parentId: 'Meble' },
      { id: 'Tkaniny i tekstylia', label: 'Tkaniny i tekstylia', count: 5, parentId: 'Meble' },
      { id: 'Toaletki', label: 'Toaletki', count: 3, parentId: 'Meble' },
      { id: 'Wieszaki i Stojaki', label: 'Wieszaki i Stojaki', count: 4, parentId: 'Meble' },
      { id: 'Witryny', label: 'Witryny', count: 3, parentId: 'Meble' },
      { id: 'Zestawy', label: 'Zestawy', count: 6, parentId: 'Meble' }
    ]
  },
  {
    id: 'Oświetlenie',
    label: 'Oświetlenie',
    count: 14,
    children: [
      { id: 'Akcesoria oświetleniowe', label: 'Akcesoria', count: 4, parentId: 'Oświetlenie' },
      { id: 'Kinkiety', label: 'Kinkiety', count: 7, parentId: 'Oświetlenie' },
      { id: 'Lampy do szynoprzewodów', label: 'Lampy do szynoprzewodów', count: 3, parentId: 'Oświetlenie' },
      { id: 'Lampy natynkowe', label: 'Lampy natynkowe', count: 5, parentId: 'Oświetlenie' },
      { id: 'Lampy ogrodowe', label: 'Lampy ogrodowe', count: 6, parentId: 'Oświetlenie' },
      { id: 'Lampy stojące', label: 'Lampy stojące', count: 8, parentId: 'Oświetlenie' },
      { id: 'Lampy wpuszczane', label: 'Lampy wpuszczane', count: 4, parentId: 'Oświetlenie' },
      { id: 'Lampy zwieszane', label: 'Lampy zwieszane', count: 9, parentId: 'Oświetlenie' },
      { id: 'Latarnie', label: 'Latarnie', count: 3, parentId: 'Oświetlenie' },
      { id: 'Profile świetlne', label: 'Profile świetlne', count: 2, parentId: 'Oświetlenie' },
      { id: 'Reflektory', label: 'Reflektory', count: 4, parentId: 'Oświetlenie' },
      { id: 'Systemy oświetleniowe', label: 'Systemy oświetleniowe', count: 5, parentId: 'Oświetlenie' },
      { id: 'Szynoprzewody', label: 'Szynoprzewody', count: 3, parentId: 'Oświetlenie' },
      { id: 'Źródła światła', label: 'Źródła światła', count: 6, parentId: 'Oświetlenie' }
    ]
  },
  {
    id: 'Elementy stałe',
    label: 'Elementy stałe',
    count: 16,
    children: [
      { id: 'Akcesoria łazienkowe', label: 'Akcesoria', count: 10, parentId: 'Elementy stałe' },
      {
        id: 'Baterie',
        label: 'Baterie',
        count: 15,
        parentId: 'Elementy stałe',
        children: [
          { id: 'Akcesoria baterie', label: 'Akcesoria', count: 5, parentId: 'Baterie' },
          { id: 'Akcesoria dla bidetów', label: 'Akcesoria dla bidetów', count: 3, parentId: 'Baterie' },
          { id: 'Baterie bidetowe', label: 'Baterie bidetowe', count: 3, parentId: 'Baterie' },
          { id: 'Baterie kuchenne', label: 'Baterie kuchenne', count: 8, parentId: 'Baterie' },
          { id: 'Baterie natryskowe', label: 'Baterie natryskowe', count: 6, parentId: 'Baterie' },
          { id: 'Baterie specjalne', label: 'Baterie specjalne', count: 4, parentId: 'Baterie' },
          { id: 'Baterie umywalkowe', label: 'Baterie umywalkowe', count: 10, parentId: 'Baterie' },
          { id: 'Baterie wannowe', label: 'Baterie wannowe', count: 5, parentId: 'Baterie' },
          { id: 'Baterie wannowo-natryskowe', label: 'Baterie wannowo-natryskowe', count: 7, parentId: 'Baterie' },
          { id: 'Baterie wolnostojące', label: 'Baterie wolnostojące', count: 4, parentId: 'Baterie' },
          { id: 'Deszczownice', label: 'Deszczownice', count: 6, parentId: 'Baterie' },
          { id: 'Dysze natryskowe', label: 'Dysze natryskowe', count: 3, parentId: 'Baterie' },
          { id: 'Systemy natryskowe podtynkowe', label: 'Systemy natryskowe podtynkowe', count: 5, parentId: 'Baterie' },
          { id: 'Systemy prysznicowe natynkowe', label: 'Systemy prysznicowe natynkowe', count: 4, parentId: 'Baterie' },
          { id: 'Wylewki', label: 'Wylewki', count: 3, parentId: 'Baterie' }
        ]
      },
      {
        id: 'Drzwi',
        label: 'Drzwi',
        count: 12,
        parentId: 'Elementy stałe',
        children: [
          { id: 'Akcesoria drzwiowe', label: 'Akcesoria drzwiowe', count: 7, parentId: 'Drzwi' },
          { id: 'Drzwi antywłamaniowe', label: 'Drzwi antywłamaniowe', count: 5, parentId: 'Drzwi' },
          { id: 'Drzwi obrotowe', label: 'Drzwi obrotowe', count: 2, parentId: 'Drzwi' },
          { id: 'Drzwi przesuwne', label: 'Drzwi przesuwne', count: 8, parentId: 'Drzwi' },
          { id: 'Drzwi szklane', label: 'Drzwi szklane', count: 4, parentId: 'Drzwi' },
          { id: 'Drzwi techniczne', label: 'Drzwi techniczne', count: 3, parentId: 'Drzwi' },
          { id: 'Drzwi wejściowe', label: 'Drzwi wejściowe', count: 9, parentId: 'Drzwi' },
          { id: 'Drzwi wewnętrzne', label: 'Drzwi wewnętrzne', count: 10, parentId: 'Drzwi' },
          { id: 'Drzwi zewnętrzne', label: 'Drzwi zewnętrzne', count: 8, parentId: 'Drzwi' },
          { id: 'Ościeżnice', label: 'Ościeżnice', count: 5, parentId: 'Drzwi' }
        ]
      },
      { id: 'Specjalistyczne', label: 'Specjalistyczne', count: 8, parentId: 'Elementy stałe' },
      { id: 'Grzejniki', label: 'Grzejniki', count: 8, parentId: 'Elementy stałe' },
      {
        id: 'Kabiny i Brodziki',
        label: 'Kabiny i Brodziki',
        count: 9,
        parentId: 'Elementy stałe',
        children: [
          { id: 'Akcesoria kabiny', label: 'Akcesoria', count: 4, parentId: 'Kabiny i Brodziki' },
          { id: 'Brodziki', label: 'Brodziki', count: 8, parentId: 'Kabiny i Brodziki' },
          { id: 'Drzwi prysznicowe', label: 'Drzwi prysznicowe', count: 6, parentId: 'Kabiny i Brodziki' },
          { id: 'Kabiny natryskowe', label: 'Kabiny natryskowe', count: 10, parentId: 'Kabiny i Brodziki' },
          { id: 'Kabiny WC', label: 'Kabiny WC', count: 3, parentId: 'Kabiny i Brodziki' },
          { id: 'Parawany nawannowe', label: 'Parawany nawannowe', count: 5, parentId: 'Kabiny i Brodziki' },
          { id: 'Systemy bezdrzwiowe', label: 'Systemy bezdrzwiowe', count: 2, parentId: 'Kabiny i Brodziki' }
        ]
      },
      {
        id: 'Kominki',
        label: 'Kominki',
        count: 8,
        parentId: 'Elementy stałe',
        children: [
          { id: 'Akcesoria kominkowe', label: 'Akcesoria kominkowe', count: 4, parentId: 'Kominki' },
          { id: 'Biokominki', label: 'Biokominki', count: 3, parentId: 'Kominki' },
          { id: 'Kominki powietrzne', label: 'Kominki powietrzne', count: 5, parentId: 'Kominki' },
          { id: 'Kominki z płaszczem wodnym', label: 'Kominki z płaszczem wodnym', count: 4, parentId: 'Kominki' },
          { id: 'Kratki kominkowe', label: 'Kratki kominkowe', count: 3, parentId: 'Kominki' },
          { id: 'Piece wolnostojące', label: 'Piece wolnostojące', count: 2, parentId: 'Kominki' },
          { id: 'Systemy kominowe', label: 'Systemy kominowe', count: 4, parentId: 'Kominki' },
          { id: 'Wkłady kominkowe', label: 'Wkłady kominkowe', count: 3, parentId: 'Kominki' }
        ]
      },
      {
        id: 'Natryski',
        label: 'Natryski',
        count: 7,
        parentId: 'Elementy stałe',
        children: [
          { id: 'Akcesoria prysznicowe', label: 'Akcesoria prysznicowe', count: 4, parentId: 'Natryski' },
          { id: 'Deszczownice', label: 'Deszczownice', count: 3, parentId: 'Natryski' },
          { id: 'Słuchawki natryskowe', label: 'Słuchawki natryskowe', count: 5, parentId: 'Natryski' },
          { id: 'Systemy podtynkowe', label: 'Systemy podtynkowe', count: 4, parentId: 'Natryski' },
          { id: 'Węże natryskowe', label: 'Węże natryskowe', count: 3, parentId: 'Natryski' },
          { id: 'Zestawy natryskowe', label: 'Zestawy natryskowe', count: 2, parentId: 'Natryski' }
        ]
      },
      {
        id: 'Okna',
        label: 'Okna',
        count: 14,
        parentId: 'Elementy stałe',
        children: [
          { id: 'Akcesoria okienne', label: 'Akcesoria okienne', count: 5, parentId: 'Okna' },
          { id: 'Okna dachowe', label: 'Okna dachowe', count: 4, parentId: 'Okna' },
          { id: 'Okna dwukwaterowe', label: 'Okna dwukwaterowe', count: 3, parentId: 'Okna' },
          { id: 'Okna niestandartowe', label: 'Okna niestandartowe', count: 2, parentId: 'Okna' },
          { id: 'Okna podwójne', label: 'Okna podwójne', count: 4, parentId: 'Okna' },
          { id: 'Okna potrójne', label: 'Okna potrójne', count: 3, parentId: 'Okna' },
          { id: 'Okna przesuwne', label: 'Okna przesuwne', count: 5, parentId: 'Okna' },
          { id: 'Okna renowacyjne', label: 'Okna renowacyjne', count: 2, parentId: 'Okna' },
          { id: 'Okna rozwierne', label: 'Okna rozwierne', count: 4, parentId: 'Okna' },
          { id: 'Okna standardowe', label: 'Okna standardowe', count: 3, parentId: 'Okna' },
          { id: 'Okna uniwersalne', label: 'Okna uniwersalne', count: 2, parentId: 'Okna' },
          { id: 'Parapety', label: 'Parapety', count: 4, parentId: 'Okna' },
          { id: 'Rolety', label: 'Rolety', count: 3, parentId: 'Okna' },
          { id: 'Systemy okienne', label: 'Systemy okienne', count: 2, parentId: 'Okna' },
          { id: 'Żaluzje', label: 'Żaluzje', count: 3, parentId: 'Okna' }
        ]
      },
      {
        id: 'Płytki i Kamienie',
        label: 'Płytki i Kamienie',
        count: 12,
        parentId: 'Elementy stałe',
        children: [
          { id: 'Elementy dekoracyjne i Dodatki', label: 'Elementy dekoracyjne i Dodatki', count: 5, parentId: 'Płytki i Kamienie' },
          { id: 'Gresy', label: 'Gresy', count: 4, parentId: 'Płytki i Kamienie' },
          { id: 'Kafle piecowe', label: 'Kafle piecowe', count: 3, parentId: 'Płytki i Kamienie' },
          { id: 'Kamień elewacyjny i ścienny', label: 'Kamień elewacyjny i ścienny', count: 4, parentId: 'Płytki i Kamienie' },
          { id: 'Kamień naturalny', label: 'Kamień naturalny', count: 3, parentId: 'Płytki i Kamienie' },
          { id: 'Klinkier', label: 'Klinkier', count: 2, parentId: 'Płytki i Kamienie' },
          { id: 'Mozaiki', label: 'Mozaiki', count: 4, parentId: 'Płytki i Kamienie' },
          { id: 'Płytki podłogowe', label: 'Płytki podłogowe', count: 5, parentId: 'Płytki i Kamienie' },
          { id: 'Płytki ścienne', label: 'Płytki ścienne', count: 4, parentId: 'Płytki i Kamienie' },
          { id: 'Spieki kwarcowe', label: 'Spieki kwarcowe', count: 3, parentId: 'Płytki i Kamienie' }
        ]
      },
      {
        id: 'Podłogi i Ściany',
        label: 'Podłogi i Ściany',
        count: 13,
        parentId: 'Elementy stałe',
        children: [
          { id: 'Akcesoria podłogowe', label: 'Akcesoria', count: 5, parentId: 'Podłogi i Ściany' },
          { id: 'Deski podłogowe', label: 'Deski podłogowe', count: 4, parentId: 'Podłogi i Ściany' },
          { id: 'Listwy dekoracyjne', label: 'Listwy dekoracyjne', count: 3, parentId: 'Podłogi i Ściany' },
          { id: 'Panele akustyczne', label: 'Panele akustyczne', count: 4, parentId: 'Podłogi i Ściany' },
          { id: 'Panele podłogowe', label: 'Panele podłogowe', count: 5, parentId: 'Podłogi i Ściany' },
          { id: 'Panele ścienne', label: 'Panele ścienne', count: 4, parentId: 'Podłogi i Ściany' },
          { id: 'Parkiety', label: 'Parkiety', count: 3, parentId: 'Podłogi i Ściany' },
          { id: 'Posadzki', label: 'Posadzki', count: 2, parentId: 'Podłogi i Ściany' },
          { id: 'Wykładziny akustyczne', label: 'Wykładziny akustyczne', count: 4, parentId: 'Podłogi i Ściany' },
          { id: 'Wykładziny dywanowe', label: 'Wykładziny dywanowe', count: 3, parentId: 'Podłogi i Ściany' },
          { id: 'Wykładziny elastyczne', label: 'Wykładziny elastyczne', count: 2, parentId: 'Podłogi i Ściany' },
          { id: 'Wykładziny PVC', label: 'Wykładziny PVC', count: 4, parentId: 'Podłogi i Ściany' }
        ]
      },
      {
        id: 'Schody',
        label: 'Schody',
        count: 5,
        parentId: 'Elementy stałe',
        children: [
          { id: 'Akcesoria schodowe', label: 'Akcesoria', count: 4, parentId: 'Schody' },
          { id: 'Deski na taras', label: 'Deski na taras', count: 3, parentId: 'Schody' },
          { id: 'Deski podłogowe', label: 'Deski podłogowe', count: 4, parentId: 'Schody' },
          { id: 'Listwy dekoracyjne', label: 'Listwy dekoracyjne', count: 3, parentId: 'Schody' },
          { id: 'Panele akustyczne', label: 'Panele akustyczne', count: 2, parentId: 'Schody' },
          { id: 'Panele podłogowe', label: 'Panele podłogowe', count: 4, parentId: 'Schody' },
          { id: 'Panele ścienne', label: 'Panele ścienne', count: 3, parentId: 'Schody' },
          { id: 'Parkiety', label: 'Parkiety', count: 2, parentId: 'Schody' },
          { id: 'Posadzki', label: 'Posadzki', count: 3, parentId: 'Schody' },
          { id: 'Wykładziny akustyczne', label: 'Wykładziny akustyczne', count: 2, parentId: 'Schody' },
          { id: 'Wykładziny dywanowe', label: 'Wykładziny dywanowe', count: 3, parentId: 'Schody' },
          { id: 'Wykładziny elastyczne', label: 'Wykładziny elastyczne', count: 2, parentId: 'Schody' },
          { id: 'Wykładziny PVC', label: 'Wykładziny PVC', count: 3, parentId: 'Schody' }
        ]
      },
      {
        id: 'Umywalki',
        label: 'Umywalki',
        count: 10,
        parentId: 'Elementy stałe',
        children: [
          { id: 'Postumenty i Półpostumenty', label: 'Postumenty i Półpostumenty', count: 4, parentId: 'Umywalki' },
          { id: 'Umywalki blatowe', label: 'Umywalki blatowe', count: 3, parentId: 'Umywalki' },
          { id: 'Umywalki meblowe', label: 'Umywalki meblowe', count: 4, parentId: 'Umywalki' },
          { id: 'Umywalki nablatowe', label: 'Umywalki nablatowe', count: 3, parentId: 'Umywalki' },
          { id: 'Umywalki podblatowe', label: 'Umywalki podblatowe', count: 2, parentId: 'Umywalki' },
          { id: 'Umywalki półblatowe', label: 'Umywalki półblatowe', count: 3, parentId: 'Umywalki' },
          { id: 'Umywalki wiszące', label: 'Umywalki wiszące', count: 4, parentId: 'Umywalki' },
          { id: 'Umywalki wolnostojące', label: 'Umywalki wolnostojące', count: 3, parentId: 'Umywalki' }
        ]
      },
      {
        id: 'Wanny',
        label: 'Wanny',
        count: 8,
        parentId: 'Elementy stałe',
        children: [
          { id: 'Akcesoria wannowe', label: 'Akcesoria wannowe', count: 4, parentId: 'Wanny' },
          { id: 'Wanny asymetryczne', label: 'Wanny asymetryczne', count: 3, parentId: 'Wanny' },
          { id: 'Wanny do zabudowy', label: 'Wanny do zabudowy', count: 4, parentId: 'Wanny' },
          { id: 'Wanny narożne', label: 'Wanny narożne', count: 3, parentId: 'Wanny' },
          { id: 'Wanny nietypowe', label: 'Wanny nietypowe', count: 2, parentId: 'Wanny' },
          { id: 'Wanny wolnostojące', label: 'Wanny wolnostojące', count: 4, parentId: 'Wanny' },
          { id: 'Wanny z hydromasażem', label: 'Wanny z hydromasażem', count: 3, parentId: 'Wanny' }
        ]
      },
      {
        id: 'WC',
        label: 'WC',
        count: 6,
        parentId: 'Elementy stałe',
        children: [
          { id: 'Bidety', label: 'Bidety', count: 3, parentId: 'WC' },
          { id: 'WC stojące', label: 'WC stojące', count: 4, parentId: 'WC' },
          { id: 'WC wiszące', label: 'WC wiszące', count: 3, parentId: 'WC' },
          { id: 'Pisuary', label: 'Pisuary', count: 2, parentId: 'WC' }
        ]
      },
      {
        id: 'Zlewy i Zlewozmywaki',
        label: 'Zlewy i Zlewozmywaki',
        count: 7,
        parentId: 'Elementy stałe',
        children: [
          { id: 'Zlewy kwadratowe', label: 'Zlewy kwadratowe', count: 4, parentId: 'Zlewy i Zlewozmywaki' },
          { id: 'Zlewy nietypowe', label: 'Zlewy nietypowe', count: 3, parentId: 'Zlewy i Zlewozmywaki' },
          { id: 'Zlewy okrągłe', label: 'Zlewy okrągłe', count: 2, parentId: 'Zlewy i Zlewozmywaki' },
          { id: 'Zlewy owalne', label: 'Zlewy owalne', count: 3, parentId: 'Zlewy i Zlewozmywaki' }
        ]
      }
    ]
  },
  {
    id: 'Urządzenia',
    label: 'Urządzenia',
    count: 5,
    children: [
      { id: 'AGD', label: 'AGD', count: 15, parentId: 'Urządzenia' },
      { id: 'AGD do zabudowy', label: 'AGD do zabudowy', count: 12, parentId: 'Urządzenia' },
      { id: 'AGD małe', label: 'AGD małe', count: 18, parentId: 'Urządzenia' },
      { id: 'Urządzenia grzewcze', label: 'Urządzenia grzewcze', count: 8, parentId: 'Urządzenia' },
      { id: 'Wentylacja i Klimatyzacja', label: 'Wentylacja i Klimatyzacja', count: 10, parentId: 'Urządzenia' }
    ]
  },
  {
    id: 'Mała architektura',
    label: 'Mała architektura',
    count: 25,
    children: [
      {
        id: 'Stojaki na rowery',
        label: 'Stojaki na rowery',
        count: 15,
        parentId: 'Mała architektura',
        children: [
          { id: 'Stojaki rowerowe szeregowe', label: 'Stojaki rowerowe szeregowe', count: 1, parentId: 'Stojaki na rowery' },
          { id: 'Stojaki na rowery typu U', label: 'Stojaki na rowery typu U', count: 1, parentId: 'Stojaki na rowery' },
          { id: 'Stojaki spiralne na rowery', label: 'Stojaki spiralne na rowery', count: 1, parentId: 'Stojaki na rowery' },
          { id: 'Stojaki rowerowe dwupoziomowe', label: 'Stojaki rowerowe dwupoziomowe', count: 1, parentId: 'Stojaki na rowery' },
          { id: 'Stojaki rowerowe z reklamą', label: 'Stojaki rowerowe z reklamą', count: 1, parentId: 'Stojaki na rowery' },
          { id: 'Stojaki ekspozycyjne na rowery', label: 'Stojaki ekspozycyjne na rowery', count: 1, parentId: 'Stojaki na rowery' },
          { id: 'Stojaki na rowery dziecięce', label: 'Stojaki na rowery dziecięce', count: 1, parentId: 'Stojaki na rowery' },
          { id: 'Stojaki ścienne na rowery', label: 'Stojaki ścienne na rowery', count: 1, parentId: 'Stojaki na rowery' },
          { id: 'Stojaki rowerowe ogumowane', label: 'Stojaki rowerowe ogumowane', count: 1, parentId: 'Stojaki na rowery' },
          { id: 'Stojaki rowerowe modułowe', label: 'Stojaki rowerowe modułowe', count: 1, parentId: 'Stojaki na rowery' },
          { id: 'Podpórki dla rowerów', label: 'Podpórki dla rowerów', count: 1, parentId: 'Stojaki na rowery' },
          { id: 'Stojaki na hulajnogi', label: 'Stojaki na hulajnogi', count: 1, parentId: 'Stojaki na rowery' },
          { id: 'Wieszaki rowerowe', label: 'Wieszaki rowerowe', count: 1, parentId: 'Stojaki na rowery' },
          { id: 'Stojaki rowerowe ciekawe kształty', label: 'Stojaki rowerowe ciekawe kształty', count: 1, parentId: 'Stojaki na rowery' },
          { id: 'Stacje naprawy rowerów', label: 'Stacje naprawy rowerów', count: 1, parentId: 'Stojaki na rowery' }
        ]
      },
      {
        id: 'Ławki parkowe i miejskie',
        label: 'Ławki parkowe i miejskie',
        count: 16,
        parentId: 'Mała architektura',
        children: [
          { id: 'Ławki stalowe, metalowe, ocynkowane, lakierowane', label: 'Ławki stalowe, metalowe, ocynkowane, lakierowane', count: 1, parentId: 'Ławki parkowe i miejskie' },
          { id: 'Ławki ze stali nierdzewnej', label: 'Ławki ze stali nierdzewnej', count: 1, parentId: 'Ławki parkowe i miejskie' },
          { id: 'Ławki żeliwne', label: 'Ławki żeliwne', count: 1, parentId: 'Ławki parkowe i miejskie' },
          { id: 'Ławki betonowe z betonu płukanego lub architektonicznego', label: 'Ławki betonowe z betonu płukanego lub architektonicznego', count: 1, parentId: 'Ławki parkowe i miejskie' },
          { id: 'Ławki drewniane', label: 'Ławki drewniane', count: 1, parentId: 'Ławki parkowe i miejskie' },
          { id: 'Ławki dworcowe, peronowe, do hali', label: 'Ławki dworcowe, peronowe, do hali', count: 1, parentId: 'Ławki parkowe i miejskie' },
          { id: 'Ławki dwustronne – na perony, lotniska i do poczekalni', label: 'Ławki dwustronne – na perony, lotniska i do poczekalni', count: 1, parentId: 'Ławki parkowe i miejskie' },
          { id: 'Ławki łukowe i okrągłe', label: 'Ławki łukowe i okrągłe', count: 1, parentId: 'Ławki parkowe i miejskie' },
          { id: 'Krzesła miejskie', label: 'Krzesła miejskie', count: 1, parentId: 'Ławki parkowe i miejskie' },
          { id: 'Ławki z deskami z tworzywa', label: 'Ławki z deskami z tworzywa', count: 1, parentId: 'Ławki parkowe i miejskie' },
          { id: 'Ławki aluminiowe', label: 'Ławki aluminiowe', count: 1, parentId: 'Ławki parkowe i miejskie' },
          { id: 'Ławki bez oparcia', label: 'Ławki bez oparcia', count: 1, parentId: 'Ławki parkowe i miejskie' },
          { id: 'Ławki na murek', label: 'Ławki na murek', count: 1, parentId: 'Ławki parkowe i miejskie' },
          { id: 'Ławki na osiedle', label: 'Ławki na osiedle', count: 1, parentId: 'Ławki parkowe i miejskie' },
          { id: 'Ławki na plac zabaw', label: 'Ławki na plac zabaw', count: 1, parentId: 'Ławki parkowe i miejskie' },
          { id: 'Ławki na podwórko', label: 'Ławki na podwórko', count: 1, parentId: 'Ławki parkowe i miejskie' },
          { id: 'Ławki na skwer', label: 'Ławki na skwer', count: 1, parentId: 'Ławki parkowe i miejskie' },
          { id: 'Ławki do ogrodu', label: 'Ławki do ogrodu', count: 1, parentId: 'Ławki parkowe i miejskie' }
        ]
      },
      {
        id: 'Kosze na śmieci miejskie, uliczne, parkowe',
        label: 'Kosze na śmieci miejskie, uliczne, parkowe',
        count: 11,
        parentId: 'Mała architektura',
        children: [
          { id: 'Kosze na śmieci stalowe, metalowe, ocynkowane, lakierowane', label: 'Kosze na śmieci stalowe, metalowe, ocynkowane, lakierowane', count: 1, parentId: 'Kosze na śmieci miejskie, uliczne, parkowe' },
          { id: 'Kosze na śmieci stalowo drewniane', label: 'Kosze na śmieci stalowo drewniane', count: 1, parentId: 'Kosze na śmieci miejskie, uliczne, parkowe' },
          { id: 'Kosze na śmieci ze stali nierdzewnej', label: 'Kosze na śmieci ze stali nierdzewnej', count: 1, parentId: 'Kosze na śmieci miejskie, uliczne, parkowe' },
          { id: 'Kosze do segregacji śmieci', label: 'Kosze do segregacji śmieci', count: 1, parentId: 'Kosze na śmieci miejskie, uliczne, parkowe' },
          { id: 'Kosze betonowe na śmieci', label: 'Kosze betonowe na śmieci', count: 1, parentId: 'Kosze na śmieci miejskie, uliczne, parkowe' },
          { id: 'Kosze na śmieci żeliwne', label: 'Kosze na śmieci żeliwne', count: 1, parentId: 'Kosze na śmieci miejskie, uliczne, parkowe' },
          { id: 'Kosze na psie odchody', label: 'Kosze na psie odchody', count: 1, parentId: 'Kosze na śmieci miejskie, uliczne, parkowe' },
          { id: 'Kosze antyterrorystyczne, na dworce', label: 'Kosze antyterrorystyczne, na dworce', count: 1, parentId: 'Kosze na śmieci miejskie, uliczne, parkowe' },
          { id: 'Kosze miejskie z listwami z kompozytu', label: 'Kosze miejskie z listwami z kompozytu', count: 1, parentId: 'Kosze na śmieci miejskie, uliczne, parkowe' },
          { id: 'Kosze do ogrodu', label: 'Kosze do ogrodu', count: 1, parentId: 'Kosze na śmieci miejskie, uliczne, parkowe' },
          { id: 'Kosze na plac zabaw', label: 'Kosze na plac zabaw', count: 1, parentId: 'Kosze na śmieci miejskie, uliczne, parkowe' }
        ]
      },
      {
        id: 'Place Zabaw',
        label: 'Place Zabaw',
        count: 20,
        parentId: 'Mała architektura',
        children: [
          { id: 'Akcesoria place zabaw', label: 'Akcesoria', count: 1, parentId: 'Place Zabaw' },
          { id: 'Bujaki', label: 'Bujaki', count: 1, parentId: 'Place Zabaw' },
          { id: 'Domki', label: 'Domki', count: 1, parentId: 'Place Zabaw' },
          { id: 'Drabinki', label: 'Drabinki', count: 1, parentId: 'Place Zabaw' },
          { id: 'Gry', label: 'Gry', count: 1, parentId: 'Place Zabaw' },
          { id: 'Huśtawki', label: 'Huśtawki', count: 1, parentId: 'Place Zabaw' },
          { id: 'Karuzele', label: 'Karuzele', count: 1, parentId: 'Place Zabaw' },
          { id: 'Kręciołki', label: 'Kręciołki', count: 1, parentId: 'Place Zabaw' },
          { id: 'Lokomotywy', label: 'Lokomotywy', count: 1, parentId: 'Place Zabaw' },
          { id: 'Panele edukacyjne', label: 'Panele edukacyjne', count: 1, parentId: 'Place Zabaw' },
          { id: 'Piaskownice', label: 'Piaskownice', count: 1, parentId: 'Place Zabaw' },
          { id: 'Równoważnie', label: 'Równoważnie', count: 1, parentId: 'Place Zabaw' },
          { id: 'Slalomy', label: 'Slalomy', count: 1, parentId: 'Place Zabaw' },
          { id: 'Stoliki', label: 'Stoliki', count: 1, parentId: 'Place Zabaw' },
          { id: 'Ścianki wspinaczkowe', label: 'Ścianki wspinaczkowe', count: 1, parentId: 'Place Zabaw' },
          { id: 'Tablice', label: 'Tablice', count: 1, parentId: 'Place Zabaw' },
          { id: 'Tyrolki', label: 'Tyrolki', count: 1, parentId: 'Place Zabaw' },
          { id: 'Wagoniki', label: 'Wagoniki', count: 1, parentId: 'Place Zabaw' },
          { id: 'Wieże', label: 'Wieże', count: 1, parentId: 'Place Zabaw' },
          { id: 'Zestawy zabawowe', label: 'Zestawy zabawowe', count: 1, parentId: 'Place Zabaw' },
          { id: 'Zjeżdżalnie', label: 'Zjeżdżalnie', count: 1, parentId: 'Place Zabaw' }
        ]
      },
      { id: 'Skatepark', label: 'Skatepark', count: 4, parentId: 'Mała architektura' },
      { id: 'Pumptrack', label: 'Pumptrack', count: 4, parentId: 'Mała architektura' },
      { id: 'Wakepark', label: 'Wakepark', count: 4, parentId: 'Mała architektura' },
      { id: 'Wavepark', label: 'Wavepark', count: 4, parentId: 'Mała architektura' },
      {
        id: 'Donice miejskie i parkowe',
        label: 'Donice miejskie i parkowe',
        count: 7,
        parentId: 'Mała architektura',
        children: [
          { id: 'Donice stalowo drewniane', label: 'Donice stalowo drewniane', count: 1, parentId: 'Donice miejskie i parkowe' },
          { id: 'Donice stalowe', label: 'Donice stalowe', count: 1, parentId: 'Donice miejskie i parkowe' },
          { id: 'Donice ze stali nierdzewnej', label: 'Donice ze stali nierdzewnej', count: 1, parentId: 'Donice miejskie i parkowe' },
          { id: 'Donice betonowe', label: 'Donice betonowe', count: 1, parentId: 'Donice miejskie i parkowe' },
          { id: 'Donice ogrodowe', label: 'Donice ogrodowe', count: 1, parentId: 'Donice miejskie i parkowe' },
          { id: 'Gazony i Palisady', label: 'Gazony i Palisady', count: 1, parentId: 'Donice miejskie i parkowe' },
          { id: 'Kraty i osłony pod drzewa', label: 'Kraty i osłony pod drzewa', count: 1, parentId: 'Donice miejskie i parkowe' },
          { id: 'Osłony pionowe do drzew', label: 'Osłony pionowe do drzew', count: 1, parentId: 'Donice miejskie i parkowe' },
          { id: 'Karmniki', label: 'Karmniki', count: 1, parentId: 'Donice miejskie i parkowe' }
        ]
      },
      {
        id: 'Słupki miejskie, uliczne, parkowe',
        label: 'Słupki miejskie, uliczne, parkowe',
        count: 4,
        parentId: 'Mała architektura',
        children: [
          { id: 'Słupki uliczne stalowe i żeliwne', label: 'Słupki uliczne stalowe i żeliwne', count: 1, parentId: 'Słupki miejskie, uliczne, parkowe' }
        ]
      },
      {
        id: 'Barierki',
        label: 'Barierki',
        count: 5,
        parentId: 'Mała architektura',
        children: [
          { id: 'Barierki trawnikowe', label: 'Barierki trawnikowe', count: 1, parentId: 'Barierki' }
        ]
      },
      { id: 'Tablice ogłoszeniowe i informacyjne zewnętrzne', label: 'Tablice ogłoszeniowe i informacyjne zewnętrzne', count: 3, parentId: 'Mała architektura' },
      { id: 'Popielnice', label: 'Popielnice', count: 2, parentId: 'Mała architektura' },
      { id: 'Leżaki miejskie, parkowe, betonowe', label: 'Leżaki miejskie, parkowe, betonowe', count: 4, parentId: 'Mała architektura' },
      { id: 'Huśtawki miejskie', label: 'Huśtawki miejskie', count: 3, parentId: 'Mała architektura' },
      { id: 'Meble ogrodowo-piknikowe', label: 'Meble ogrodowo-piknikowe', count: 6, parentId: 'Mała architektura' },
      { id: 'Płyty i kostki brukowe', label: 'Płyty i kostki brukowe', count: 8, parentId: 'Mała architektura' },
      {
        id: 'Wiata rowerowa',
        label: 'Wiata rowerowa',
        count: 3,
        parentId: 'Mała architektura',
        children: [
          { id: 'Wiaty rowerowe na 5 stanowisk', label: 'Wiaty rowerowe na 5 stanowisk', count: 1, parentId: 'Wiata rowerowa' },
          { id: 'Wiaty rowerowe na 10 stanowisk', label: 'Wiaty rowerowe na 10 stanowisk', count: 1, parentId: 'Wiata rowerowa' },
          { id: 'Wiaty rowerowe na 15 stanowisk', label: 'Wiaty rowerowe na 15 stanowisk', count: 1, parentId: 'Wiata rowerowa' },
          { id: 'Wiaty rowerowe na 20 stanowisk', label: 'Wiaty rowerowe na 20 stanowisk', count: 1, parentId: 'Wiata rowerowa' },
          { id: 'Wiaty rowerowe na 25 stanowisk', label: 'Wiaty rowerowe na 25 stanowisk', count: 1, parentId: 'Wiata rowerowa' },
          { id: 'Wiaty rowerowe na 30 stanowisk', label: 'Wiaty rowerowe na 30 stanowisk', count: 1, parentId: 'Wiata rowerowa' },
          { id: 'Wiaty rowerowe dwustronne', label: 'Wiaty rowerowe dwustronne', count: 1, parentId: 'Wiata rowerowa' }
        ]
      },
      { id: 'Zewnętrzne stoły do gier', label: 'Zewnętrzne stoły do gier w szachy, chińczyka, tenisa i piłkarzyki', count: 2, parentId: 'Mała architektura' },
      { id: 'Hamaki miejskie', label: 'Hamaki miejskie', count: 1, parentId: 'Mała architektura' },
      { id: 'Grille parkowe, osiedlowe', label: 'Grille parkowe, osiedlowe', count: 3, parentId: 'Mała architektura' },
      { id: 'Przysiadki miejskie', label: 'Przysiadki miejskie', count: 2, parentId: 'Mała architektura' },
      { id: 'Pergole miejskie', label: 'Pergole miejskie', count: 4, parentId: 'Mała architektura' },
      { id: 'Siłownie miejskie', label: 'Siłownie miejskie', count: 5, parentId: 'Mała architektura' },
      { id: 'Stacje do dezynfekcji', label: 'Stacje do dezynfekcji', count: 2, parentId: 'Mała architektura' }
    ]
  },
  {
    id: 'Konstrukcje',
    label: 'Konstrukcje',
    count: 16,
    children: [
      { id: 'Akcesoria konstrukcyjne', label: 'Akcesoria', count: 5, parentId: 'Konstrukcje' },
      { id: 'Altany ogrodowe', label: 'Altany ogrodowe', count: 7, parentId: 'Konstrukcje' },
      { id: 'Meble ogrodowe: zestawy kawowe', label: 'Meble ogrodowe: zestawy kawowe', count: 10, parentId: 'Konstrukcje' },
      { id: 'Bramy', label: 'Bramy', count: 6, parentId: 'Konstrukcje' },
      { id: 'Balie ogrodowe', label: 'Balie ogrodowe', count: 3, parentId: 'Konstrukcje' },
      { id: 'Ogrodzenia', label: 'Ogrodzenia', count: 8, parentId: 'Konstrukcje' },
      { id: 'Profile', label: 'Profile', count: 4, parentId: 'Konstrukcje' },
      { id: 'Przegrody pionowe', label: 'Przegrody pionowe', count: 3, parentId: 'Konstrukcje' },
      { id: 'System zadaszeń', label: 'System zadaszeń', count: 5, parentId: 'Konstrukcje' },
      { id: 'Systemy modułowe', label: 'Systemy modułowe', count: 4, parentId: 'Konstrukcje' },
      { id: 'Wiaty', label: 'Wiaty', count: 6, parentId: 'Konstrukcje' },
      { id: 'Zestawy kawowe', label: 'Zestawy kawowe', count: 5, parentId: 'Konstrukcje' },
      { id: 'Fotele techorattanowe', label: 'Fotele techorattanowe', count: 7, parentId: 'Konstrukcje' },
      { id: 'Fotele bujane', label: 'Fotele bujane', count: 7, parentId: 'Konstrukcje' },
      { id: 'Leżaki do ogrodu', label: 'Leżaki do ogrodu', count: 4, parentId: 'Konstrukcje' },
      { id: 'Sauny ogrodowe', label: 'Sauny ogrodowe', count: 2, parentId: 'Konstrukcje' }
    ]
  },
  {
    id: 'Dekoracje i Dodatki',
    label: 'Dekoracje i Dodatki',
    count: 21,
    children: [
      { id: 'Akcesoria kuchenne', label: 'Akcesoria kuchenne', count: 8, parentId: 'Dekoracje i Dodatki' },
      { id: 'Akcesoria łazienkowe dek', label: 'Akcesoria łazienkowe', count: 7, parentId: 'Dekoracje i Dodatki' },
      { id: 'Dekoracje drobne', label: 'Dekoracje drobne', count: 10, parentId: 'Dekoracje i Dodatki' },
      { id: 'Dekoracje wiszące', label: 'Dekoracje wiszące', count: 6, parentId: 'Dekoracje i Dodatki' },
      { id: 'Donice i Osłonki', label: 'Donice, Doniczki i Osłonki', count: 9, parentId: 'Dekoracje i Dodatki' },
      { id: 'Figurki dekoracyjne', label: 'Figurki dekoracyjne', count: 5, parentId: 'Dekoracje i Dodatki' },
      { id: 'Koszyki i Pudełka', label: 'Koszyki i Pudełka', count: 6, parentId: 'Dekoracje i Dodatki' },
      { id: 'Lampiony i Świeczniki', label: 'Lampiony i Świeczniki', count: 7, parentId: 'Dekoracje i Dodatki' },
      { id: 'Lustra', label: 'Lustra', count: 8, parentId: 'Dekoracje i Dodatki' },
      { id: 'Poduszki i Siedziska', label: 'Poduszki i Siedziska', count: 9, parentId: 'Dekoracje i Dodatki' },
      { id: 'Ramki na zdjęcia', label: 'Ramki na zdjęcia', count: 4, parentId: 'Dekoracje i Dodatki' },
      { id: 'Skrzynki drewniane', label: 'Skrzynki drewniane', count: 3, parentId: 'Dekoracje i Dodatki' },
      { id: 'Stojaki na książki i gazety', label: 'Stojaki na książki i gazety', count: 2, parentId: 'Dekoracje i Dodatki' },
      { id: 'Świece i Świeczki', label: 'Świece i Świeczki', count: 6, parentId: 'Dekoracje i Dodatki' },
      { id: 'Tapety', label: 'Tapety', count: 8, parentId: 'Dekoracje i Dodatki' },
      { id: 'Tekstylia', label: 'Tekstylia', count: 10, parentId: 'Dekoracje i Dodatki' },
      { id: 'Wazony i Dzbany', label: 'Wazony i Dzbany', count: 7, parentId: 'Dekoracje i Dodatki' },
      { id: 'Wieszaki i stojaki dek', label: 'Wieszaki i stojaki', count: 5, parentId: 'Dekoracje i Dodatki' },
      { id: 'Wycieraczki i Maty', label: 'Wycieraczki i Maty', count: 4, parentId: 'Dekoracje i Dodatki' },
      { id: 'Zabudowy dekoracyjne', label: 'Zabudowy dekoracyjne', count: 3, parentId: 'Dekoracje i Dodatki' },
      { id: 'Zielone panele', label: 'Zielone panele', count: 5, parentId: 'Dekoracje i Dodatki' }
    ]
  }
]

// Spłaszczona wersja dla zachowania kompatybilności z istniejącym kodem
export const PRODUCT_CATEGORIES = flattenCategories(PRODUCT_CATEGORIES_TREE)

// Funkcja pomocnicza do konwersji między formatami
export function flattenCategories (tree: CategoryItem[]): CategoryItem[] {
  const result: CategoryItem[] = []

  tree.forEach(item => {
    // Dodaj główną kategorię
    result.push({
      id: item.id,
      label: item.label,
      count: item.count
    })

    // Dodaj podkategorie jeśli istnieją
    if ((item.children != null) && (item.children.length > 0)) {
      item.children.forEach(child => {
        result.push({
          id: child.id,
          label: child.label,
          count: child.count,
          parentId: child.parentId
        })

        // Dodaj kategorie trzeciego poziomu jeśli istnieją
        if ((child.children != null) && (child.children.length > 0)) {
          child.children.forEach(grandchild => {
            result.push({
              id: grandchild.id,
              label: grandchild.label,
              count: grandchild.count,
              parentId: grandchild.parentId
            })
          })
        }
      })
    }
  })

  return result
}
